import { useEffect, useState } from 'react';

/**
 * Whether the component has mounted on the client.
 *
 * Unlike `useIsMountedRef`, this re-renders when it flips, so a component that
 * renders null until mounted actually reappears. Use it to gate browser-only
 * state (localStorage, window) without a hydration mismatch.
 *
 * The ref version remains for liveness checks inside callbacks, where a
 * re-render is unwanted. It currently has no callers.
 */
export const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted;
};
